import { get, post } from "@services/apiService.js";

export default {

  /**
   * Check if the Makewebeasy AI plugin is initialized
   * GET /v4/plugin-manager/v1/plugins/status
   * @param {Object} params - { pluginId }
   */
  checkInitPluginMakewebeasyAI() {
    return get(`/v4/plugin-manager/v1/plugins/status`, { pluginId: 3 }) // 3 = Makewebeasy AI
      .then((response) => {
        return response.data || {};
      })
      .catch((error) => {
        throw error;
      })
  },

  /**
   * Get content tone for AI generate
   * GET /v4/ai-manager/v1/utility/content-tone
   */
  getContentTone() {    
    return get(`/v4/ai-manager/v1/utility/content-tone`)
      .then((response) => {
        return response.data || [];
      })
      .catch((error) => {
        throw error;
      });
  },

  /**
   * Get suggestion prompts for AI generate
   * GET /v4/ai-manager/v1/generate/text/suggest-prompt
   */
  getSuggestPrompt() {
    return get(`/v4/ai-manager/v1/generate/text/suggest-prompt`)
      .then((response) => {
        return response.data || {};
      })
      .catch((error) => {
        throw error;
      });
  },

  /**
   * Get generate text detail (polling for result)
   * GET /v4/ai-manager/v1/generate/text/{sessionId}
   * @param {String} sessionId
   */
  getGenerateTextDetail(sessionId) {
    return get(`/v4/ai-manager/v1/generate/text/${sessionId}`)
      .then((response) => {
        return response.data || {};
      })
      .catch((error) => {
        throw error;
      });
  },

  /**
   * Get credit available
   * GET /v4/plugin-manager/v1/credits/available
   * @param {Object} params - { pluginId }
   */
  getCreditAvailable(params = {}) {
    return get(`/v4/plugin-manager/v1/credits/available`, params)
      .then(response => response.data || {})
      .catch(error => { throw error });
  },

  /**
   * Post credit check
   * POST /v4/ai-manager/v1/generate/credit-check
   * @param {Object} data - { sessionId, prompt }
   */
  postCreditCheck(data) {
    // GENERATE_TEXT,
    // REVISE_TEXT,
    // TRANSLATE_TEXT
    return post(`/v4/ai-manager/v1/generate/credit-check`, data)
      .then((response) => {
        return response.data || {};
      })
      .catch((error) => {
        throw error;
      });
  },

  /**
   * Post generate text - send prompt to AI
   * POST /v4/ai-manager/v1/generate/text
   * @param {Object} data - { sessionId, fullText, selectedText, promptName, prompt }
   */
  postGenerateText(data) {
    return post(`/v4/ai-manager/v1/generate/text`, data)
      .then((response) => {
        return response.data || {};
      })
      .catch((error) => {
        console.log('postGenerateText error', error);
        throw error;
      });
  },
  /**
   * Post revise generate text - send prompt to AI
   * POST /v4/ai-manager/v1/generate/text/revise 
   * @param {Object} data - { sessionId, fullText, selectedText, promptName, prompt, contentTone, language }
   */
  postReviseGenerateText(data) {
    return post(`/v4/ai-manager/v1/generate/text/revise`, data)
      .then((response) => {
        return response.data || {};
      })
      .catch((error) => {
        throw error;
      });
  },

  /**
   * Post translate generate text
   * POST /v4/ai-manager/v1/generate/text/translate
   * @param {Object} data - { sessionId, language, fullText, selectedText, targetLanguage }
   */
  postTranslateText(data) {
    return post(`/v4/ai-manager/v1/generate/text/translate`, data)
      .then((response) => {
        return response.data || {};
      })
      .catch((error) => {
        throw error;
      });
  },

  
};
